module.exports = __webpack_public_path__ + "media/images/chat-edit-4971cdc4.svg";